function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-30);}.cls-10,.cls-12,.cls-14,.cls-16,.cls-19,.cls-2,.cls-22,.cls-23,.cls-26,.cls-28,.cls-29,.cls-31,.cls-33,.cls-35,.cls-37,.cls-39,.cls-4,.cls-41,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115);}.cls-3{mask:url(#mask-2);filter:url(#luminosity-noclip-35);}.cls-4{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_109);}.cls-5{mask:url(#mask-3);filter:url(#luminosity-noclip-36);}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_107);}.cls-7{mask:url(#mask-4);filter:url(#luminosity-noclip-37);}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_109-2);}.cls-9{mask:url(#mask-5);filter:url(#luminosity-noclip-38);}.cls-10{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_107-2);}.cls-11{mask:url(#mask-6);filter:url(#luminosity-noclip-39);}.cls-12{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_107-3);}.cls-13,.cls-24{mask:url(#mask-7);}.cls-13{filter:url(#luminosity-noclip-31);}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_109-3);}.cls-15,.cls-17{mask:url(#mask-8);}.cls-15{filter:url(#luminosity-invert-noclip);}.cls-16{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_104);}.cls-18,.cls-20{mask:url(#mask-11);}.cls-18{filter:url(#luminosity-noclip-42);}.cls-19{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_104-4);}.cls-21{mask:url(#mask-14);}.cls-22{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_100);}.cls-23{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_64);}.cls-25{mask:url(#mask-19);filter:url(#luminosity-noclip-48);}.cls-26{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_101);}.cls-27{mask:url(#mask-20);}.cls-28{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_100-3);}.cls-29{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_64-3);}.cls-30,.cls-32{mask:url(#mask-24);}.cls-30{filter:url(#luminosity-noclip-52);}.cls-31{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_96);}.cls-33{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_33);}.cls-34{mask:url(#mask-26);filter:url(#luminosity-noclip-54);}.cls-35{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_96-2);}.cls-36{mask:url(#mask-27);filter:url(#luminosity-noclip-55);}.cls-37{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_96-3);}.cls-38{mask:url(#mask-28);filter:url(#luminosity-noclip-33);}.cls-39{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_109-5);}.cls-40{mask:url(#mask-29);filter:url(#luminosity-noclip-34);}.cls-41{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_107-4);}.cls-42,.cls-75,.cls-79{isolation:isolate;}.cls-43{fill:#051c41;}.cls-44{fill:#b9caef;}.cls-45{fill:#2c3a64;}.cls-46{fill:#00a878;}.cls-47{fill:#009164;}.cls-48{fill:#02cc9a;}.cls-49{fill:none;}.cls-50{fill:#fff;}.cls-51{mask:url(#mask-30);}.cls-52{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_17);}.cls-53{mask:url(#mask-31);}.cls-54,.cls-58,.cls-61,.cls-63,.cls-65,.cls-67,.cls-69,.cls-71,.cls-89,.cls-91{mix-blend-mode:screen;}.cls-54{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38);}.cls-55{fill:#ffa159;}.cls-56{fill:#de494b;}.cls-57{mask:url(#mask-33);}.cls-58{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38-2);}.cls-59{fill:#f88968;}.cls-60{mask:url(#mask-34);}.cls-61,.cls-65,.cls-69,.cls-71{opacity:0.67;}.cls-61{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37);}.cls-62{mask:url(#mask-35);}.cls-63{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38-3);}.cls-64{mask:url(#mask-36);}.cls-65{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-2);}.cls-66{mask:url(#mask-37);}.cls-67{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_38-4);}.cls-68{mask:url(#mask-38);}.cls-69{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-3);}.cls-70{mask:url(#mask-39);}.cls-71{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37-4);}.cls-72{mask:url(#mask-40);}.cls-73,.cls-75{opacity:0.2;}.cls-73{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_18);}.cls-74{mask:url(#mask-43);}.cls-75{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_18-2);}.cls-76{fill:#8d40a7;}.cls-77{fill:#551c81;}.cls-78{mask:url(#mask-46);}.cls-79{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2);}.cls-80{mask:url(#mask-50);}.cls-81{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);}.cls-82{mask:url(#mask-51);}.cls-83{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-2);}.cls-84{fill:#fc3467;}.cls-85{fill:#ffbf44;}.cls-86{mask:url(#mask-55);}.cls-87,.cls-89,.cls-91{opacity:0.68;}.cls-87{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_27);}.cls-88{mask:url(#mask-57);}.cls-89{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_27-2);}.cls-90{mask:url(#mask-58);}.cls-91{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_27-3);}.cls-92{fill:#f4447a;}.cls-93{fill:#c62954;}.cls-94{fill:#ed975d;}.cls-95{fill:#ffa412;}.cls-96{fill:#35488b;}.cls-97{fill:#ffb27d;}.cls-98{fill:#414c96;}.cls-99{fill:#ffb93e;}.cls-100{filter:url(#luminosity-noclip-29);}.cls-101{filter:url(#luminosity-noclip-28);}.cls-102{filter:url(#luminosity-noclip-27);}.cls-103{filter:url(#luminosity-noclip-26);}.cls-104{filter:url(#luminosity-noclip-24);}.cls-105{filter:url(#luminosity-noclip-20);}.cls-106{filter:url(#luminosity-noclip-19);}.cls-107{filter:url(#luminosity-noclip-14);}.cls-108{filter:url(#luminosity-noclip-11);}.cls-109{filter:url(#luminosity-noclip-8);}.cls-110{filter:url(#luminosity-noclip-7);}.cls-111{filter:url(#luminosity-noclip-6);}.cls-112{filter:url(#luminosity-noclip-5);}.cls-113{filter:url(#luminosity-noclip-4);}.cls-114{filter:url(#luminosity-noclip-3);}.cls-115{filter:url(#luminosity-noclip-2);}.cls-116{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip",
  x: 343.88,
  y: -11926.18,
  width: 20.51,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask",
  x: 343.88,
  y: -11926.18,
  width: 20.51,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-116"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115",
  cx: 357,
  cy: 77.17,
  r: 10.25,
  gradientTransform: "translate(-3.12 1.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#fbfbfb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#f0f0f0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#ddd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#c3c3c3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#a0a0a0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#767676"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#454545"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#0c0c0c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-2",
  x: 384.62,
  y: -11926.18,
  width: 42.04,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  x: 384.62,
  y: -11926.18,
  width: 42.04,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-115"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109",
  x1: 324.89,
  y1: 113.51,
  x2: 375.32,
  y2: 69.93,
  gradientTransform: "translate(58.23 -62.23) rotate(0.89)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#c1c1c1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#878787"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#565656"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#313131"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#161616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#060606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-3",
  x: 384.55,
  y: -11926.18,
  width: 0.98,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  x: 384.55,
  y: -11926.18,
  width: 0.98,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-114"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_107",
  x1: 181.95,
  y1: 286.79,
  x2: 183.06,
  y2: 285.83,
  gradientTransform: "matrix(1, 0.06, -0.06, 1, 219.11, -243.58)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-4",
  x: 362.15,
  y: -11926.18,
  width: 57.32,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  x: 362.15,
  y: -11926.18,
  width: 57.32,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-113"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109-2",
  x1: 224.3,
  y1: 223.38,
  x2: 291.63,
  y2: 165.2,
  gradientTransform: "translate(141.85 -159.68) rotate(2.11)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-5",
  x: 361.92,
  y: -11926.18,
  width: 3.08,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  x: 361.92,
  y: -11926.18,
  width: 3.08,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-112"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_107-2",
  x1: 86.12,
  y1: 399.97,
  x2: 89.54,
  y2: 397.01,
  gradientTransform: "matrix(1, 0.08, -0.08, 1, 307.09, -337.45)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-6",
  x: 347.96,
  y: -11926.18,
  width: 24.52,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  x: 347.96,
  y: -11926.18,
  width: 24.52,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-111"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_107-3",
  x1: 347.32,
  y1: 83.51,
  x2: 375.95,
  y2: 58.78,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-7",
  x: 351.01,
  y: -11926.18,
  width: 94.56,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-7",
  x: 351.01,
  y: -11926.18,
  width: 94.56,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-110"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109-3",
  x1: 346.34,
  y1: 84.03,
  x2: 456.08,
  y2: -10.79,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-8",
  x: 220.05,
  y: -11926.18,
  width: 149.97,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  x: 220.05,
  y: -11926.18,
  width: 149.97,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-109"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_104",
  x1: 179.17,
  y1: 150.47,
  x2: 352.73,
  y2: 9.41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#e2e2e2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#989898"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#242424"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-11",
  x: 226.72,
  y: -11926.18,
  width: 59.85,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-11",
  x: 226.72,
  y: -11926.18,
  width: 59.85,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_104-4",
  x1: 570.02,
  y1: -245.96,
  x2: 634.95,
  y2: -292.64,
  gradientTransform: "translate(-393.43 -70.74) rotate(35.53)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_104"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-14",
  x: 326.79,
  y: -11926.18,
  width: 86.7,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-14",
  x: 326.79,
  y: -11926.18,
  width: 86.7,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_100",
  x1: 309.82,
  y1: 170.5,
  x2: 415.28,
  y2: 79.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#c1c1c1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#878787"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#565656"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#313131"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#161616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#060606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_64",
  x1: 309.82,
  y1: 170.5,
  x2: 415.28,
  y2: 79.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#d6d6d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#b1b1b1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#969696"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#868686"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-19",
  x: 317.61,
  y: -11926.18,
  width: 26.48,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-19",
  x: 317.61,
  y: -11926.18,
  width: 26.48,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-106"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_101",
  cx: 333.74,
  cy: 151.54,
  r: 13.23,
  gradientTransform: "translate(-3.12 1.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#f9f9f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#e9e9e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#cecece"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#a9a9a9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#787878"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#3e3e3e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-20",
  x: 324.68,
  y: -11926.18,
  width: 38.91,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-20",
  x: 324.68,
  y: -11926.18,
  width: 38.91,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-105"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_100-3",
  x1: 408.43,
  y1: 58.5,
  x2: 456.87,
  y2: 16.92,
  gradientTransform: "matrix(1, -0.03, 0.03, 1, -92.94, 117.84)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_100"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_64-3",
  x1: 408.43,
  y1: 58.5,
  x2: 456.87,
  y2: 16.92,
  gradientTransform: "matrix(1, -0.03, 0.03, 1, -92.94, 117.84)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_64"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-24",
  x: 424.14,
  y: -11926.18,
  width: 44.05,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-24",
  x: 424.14,
  y: -11926.18,
  width: 44.05,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-104"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96",
  x1: 421.97,
  y1: 130.35,
  x2: 472.76,
  y2: 96.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#7c7c7c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#707070"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#5c5c5c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#404040"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#1c1c1c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_33",
  x1: 421.97,
  y1: 130.35,
  x2: 472.76,
  y2: 96.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#fbfbfb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#efefef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#dbdbdb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#bebebe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#9a9a9a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#6d6d6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#3a3a3a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-26",
  x: 430.5,
  y: -11926.18,
  width: 20.56,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-26",
  x: 430.5,
  y: -11926.18,
  width: 20.56,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-103"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96-2",
  x1: 428.21,
  y1: 122.83,
  x2: 452.57,
  y2: 106.63,
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-27",
  x: 436.95,
  y: -11926.18,
  width: 26,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-27",
  x: 436.95,
  y: -11926.18,
  width: 26,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-102"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96-3",
  x1: 433.49,
  y1: 122.16,
  x2: 465.65,
  y2: 100.78,
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_96"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-28",
  x: 365.52,
  y: -11926.18,
  width: 51.04,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-28",
  x: 365.52,
  y: -11926.18,
  width: 51.04,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109-5",
  x1: 116.86,
  y1: 348.26,
  x2: 174.31,
  y2: 298.62,
  gradientTransform: "translate(269.47 -294.42) rotate(3.93)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_109"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-29",
  x: 365.16,
  y: -11926.18,
  width: 4.57,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-29",
  x: 365.16,
  y: -11926.18,
  width: 4.57,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-100"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_107-4",
  x1: -16.99,
  y1: 529.39,
  x2: -11.99,
  y2: 525.07,
  gradientTransform: "translate(439.91 -466.44) rotate(6.3)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-30",
  x: 343.88,
  y: 67.97,
  width: 20.51,
  height: 20.49,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-30",
  x: 343.88,
  y: 67.97,
  width: 20.51,
  height: 20.49,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M354.14,68a10.25,10.25,0,1,0,10.25,10.25A10.22,10.22,0,0,0,354.14,68Z"
}))), /*#__PURE__*/React.createElement("radialGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_17",
  cx: 357,
  cy: 77.17,
  r: 10.25,
  gradientTransform: "translate(-3.12 1.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f88968"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#f48767"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#e98065"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#d67561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#bc655b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#995154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#6f384c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#3f1b42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#150239"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-31",
  x: 351.01,
  y: 3.9,
  width: 94.56,
  height: 76.26,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-31",
  x: 351.01,
  y: 3.9,
  width: 94.56,
  height: 76.26,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "351.01 73.35 445.57 3.9 358.5 80.16 351.01 73.35"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38",
  x1: 346.34,
  y1: 84.03,
  x2: 456.08,
  y2: -10.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f88968"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#d57461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#9c5255"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#6b354b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#461f43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#2b0f3e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#1b053a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#150239"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-33",
  x: 365.52,
  y: 22.35,
  width: 51.04,
  height: 35.44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-33",
  x: 365.52,
  y: 22.35,
  width: 51.04,
  height: 35.44,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-38"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-39",
  points: "365.52 56.32 416.57 22.35 366.92 57.78 365.52 56.32"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38-2",
  x1: 116.86,
  y1: 348.26,
  x2: 174.31,
  y2: 298.62,
  gradientTransform: "translate(269.47 -294.42) rotate(3.93)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-34",
  x: 365.16,
  y: 54.62,
  width: 4.57,
  height: 3.47,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-34",
  x: 365.16,
  y: 54.62,
  width: 4.57,
  height: 3.47,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-40"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M369.74,54.62A10.71,10.71,0,0,0,366.21,56a1,1,0,0,0-.72.28,1,1,0,0,0-.32.64,1,1,0,0,0,2,.51s0-.09.05-.14A10.75,10.75,0,0,0,369.74,54.62Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37",
  x1: -16.99,
  y1: 529.39,
  x2: -11.99,
  y2: 525.07,
  gradientTransform: "translate(439.91 -466.44) rotate(6.3)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_17"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-35",
  x: 384.62,
  y: 19.19,
  width: 42.04,
  height: 33.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-35",
  x: 384.62,
  y: 19.19,
  width: 42.04,
  height: 33.82,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "384.62 52.71 426.66 19.19 384.95 53.01 384.62 52.71"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38-3",
  x1: 324.89,
  y1: 113.51,
  x2: 375.32,
  y2: 69.93,
  gradientTransform: "translate(58.23 -62.23) rotate(0.89)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-36",
  x: 384.55,
  y: 52.28,
  width: 0.98,
  height: 0.81,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-36",
  x: 384.55,
  y: 52.28,
  width: 0.98,
  height: 0.81,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M385.53,52.28a2.22,2.22,0,0,0-.76.35.29.29,0,0,0-.16.07.25.25,0,0,0-.06.15.23.23,0,0,0,.44.09s0,0,0,0A2.59,2.59,0,0,0,385.53,52.28Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-2",
  x1: 181.95,
  y1: 286.79,
  x2: 183.06,
  y2: 285.83,
  gradientTransform: "matrix(1, 0.06, -0.06, 1, 219.11, -243.58)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_17"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-37",
  x: 362.15,
  y: 23.7,
  width: 57.32,
  height: 44.19,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-37",
  x: 362.15,
  y: 23.7,
  width: 57.32,
  height: 44.19,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "362.15 66.93 419.46 23.7 363.13 67.89 362.15 66.93"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38-4",
  x1: 224.3,
  y1: 223.38,
  x2: 291.63,
  y2: 165.2,
  gradientTransform: "translate(141.85 -159.68) rotate(2.11)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_38"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-38",
  x: 361.92,
  y: 65.67,
  width: 3.08,
  height: 2.45,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-38",
  x: 361.92,
  y: 65.67,
  width: 3.08,
  height: 2.45,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-9"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M365,65.67a7.55,7.55,0,0,0-2.38,1,.73.73,0,0,0-.49.21.69.69,0,0,0-.2.44.71.71,0,0,0,.65.76.72.72,0,0,0,.71-.45l0-.1A7.23,7.23,0,0,0,365,65.67Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-3",
  x1: 86.12,
  y1: 399.97,
  x2: 89.54,
  y2: 397.01,
  gradientTransform: "matrix(1, 0.08, -0.08, 1, 307.09, -337.45)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_17"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-39",
  x: 347.96,
  y: 61.77,
  width: 24.52,
  height: 21.98,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-39",
  x: 347.96,
  y: 61.77,
  width: 24.52,
  height: 21.98,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-11"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M372.48,61.77A60.64,60.64,0,0,0,353.32,72a5.88,5.88,0,1,0,6.17,7.55,7.68,7.68,0,0,0,.19-.83A61.29,61.29,0,0,0,372.48,61.77Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37-4",
  x1: 347.32,
  y1: 83.51,
  x2: 375.95,
  y2: 58.78,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_17"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-invert-noclip",
  x: 220.05,
  y: 0,
  width: 149.97,
  height: 121.18,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0",
  result: "invert"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "invert",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-40",
  x: 220.05,
  y: 0,
  width: 149.97,
  height: 121.18,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-15"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M368,2.85A8.34,8.34,0,0,0,356.28,2L280,66.8a1.75,1.75,0,0,1-2.53-.27l0,0a1.76,1.76,0,0,1,.24-2.4l45.49-39.21a5.47,5.47,0,0,0,.3-8h0A5.48,5.48,0,0,0,316,16.6L221.94,97.51c-2.12,1.83-2.49,6.6-.95,8.86,3.21,2.93,3.15,7.26,5.85,10.62l5-4.33a5.33,5.33,0,0,0,1.08,1.94l4,4.69a5.5,5.5,0,0,0,7.73.57L367.12,14.65A8.33,8.33,0,0,0,368,2.85Z"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-40",
  x: 220.05,
  y: 0,
  width: 149.97,
  height: 121.18,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_18",
  x1: 179.17,
  y1: 150.47,
  x2: 352.73,
  y2: 9.41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#f81f95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#ec3ca3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#ce86c6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#9efafd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9cffff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-42",
  x: 226.72,
  y: 33.97,
  width: 59.85,
  height: 52.47,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-43",
  x: 226.72,
  y: 33.97,
  width: 59.85,
  height: 52.47,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-18"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-19",
  x: 219.1,
  y: 56.69,
  width: 75.09,
  height: 7.04,
  rx: 2.12,
  transform: "translate(22.72 181.75) rotate(-40.66)"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_18-2",
  x1: 570.02,
  y1: -245.96,
  x2: 634.95,
  y2: -292.64,
  gradientTransform: "translate(-393.43 -70.74) rotate(35.53)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_18"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-46",
  x: 326.79,
  y: 84.74,
  width: 86.7,
  height: 72.03,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-21"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M413.41,84.88c-2.6-3-69.17,46.58-84.23,59.43-.82.69-1.61,1.39-2.39,2.08l10.12,10.38c.56-.47,1.13-.94,1.69-1.43C353.67,142.49,416,87.92,413.41,84.88Z"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-45",
  x: 326.79,
  y: 84.74,
  width: 86.7,
  height: 72.03,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2",
  x1: 309.82,
  y1: 170.5,
  x2: 415.28,
  y2: 79.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#fc3467"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#fc3966"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fd695a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#fe8e50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#ffa94a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ffb945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffbf44"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-48",
  x: 317.61,
  y: 139.34,
  width: 26.48,
  height: 26.46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-50",
  x: 317.61,
  y: 139.34,
  width: 26.48,
  height: 26.46,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-25"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M330.85,139.34a13.22,13.22,0,1,0,13.25,13.23A13.21,13.21,0,0,0,330.85,139.34Z"
}))), /*#__PURE__*/React.createElement("radialGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
  cx: 333.74,
  cy: 151.54,
  r: 13.23,
  gradientTransform: "translate(-3.12 1.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fc3467"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#f63365"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e63061"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#cb2b5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#a62450"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#751c44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#3b1134"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#140a2a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-51",
  x: 324.68,
  y: 125.53,
  width: 38.91,
  height: 33.14,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-27"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M324.77,151.23s2-10.69,16.31-17.64c0,0-6.71,6.54-8.88,12.29,0,0,8.28-11.58,21.95-16.84,0,0-14.28,10.33-15.85,14.81l4.39-2.33s-1,3.59-3.39,5.34c0,0,21.91-17.18,24.29-21.33,0,0-10.07,19-21.57,25.53,0,0,8.45-2.94,11.31-6.86,0,0-8.19,11.49-18.82,14.06a10.58,10.58,0,0,1-5.09.17C327,157.78,324.15,155.86,324.77,151.23Z"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-49",
  x: 324.68,
  y: 125.53,
  width: 38.91,
  height: 33.14,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-2",
  x1: 408.43,
  y1: 58.5,
  x2: 456.87,
  y2: 16.92,
  gradientTransform: "matrix(1, -0.03, 0.03, 1, -92.94, 117.84)",
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-52",
  x: 424.14,
  y: 93.07,
  width: 44.05,
  height: 38.37,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-55",
  x: 424.14,
  y: 93.07,
  width: 44.05,
  height: 38.37,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-30"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M424.14,124.85l43.19-31.67a.54.54,0,0,1,.7.82l-37.18,37.45Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_27",
  x1: 421.97,
  y1: 130.35,
  x2: 472.76,
  y2: 96.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#f4447a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#f04379"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#e44074"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#d03b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#b33363"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#8f2a56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#621e46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#2f1133"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#140a2a"
})), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-54",
  x: 430.5,
  y: 106.17,
  width: 20.56,
  height: 16.32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-57",
  x: 430.5,
  y: 106.17,
  width: 20.56,
  height: 16.32,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-34"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-35",
  points: "430.5 122.07 451.06 106.17 430.92 122.49 430.5 122.07"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_27-2",
  x1: 428.21,
  y1: 122.83,
  x2: 452.57,
  y2: 106.63,
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_27"
}), /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip-55",
  x: 436.95,
  y: 99.11,
  width: 26,
  height: 23.59,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-58",
  x: 436.95,
  y: 99.11,
  width: 26,
  height: 23.59,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-37",
  points: "436.95 121.83 462.95 99.11 437.9 122.7 436.95 121.83"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_27-3",
  x1: 433.49,
  y1: 122.16,
  x2: 465.65,
  y2: 100.78,
  xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_27"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Fail 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-42"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M522.6,302c.13-7,58.51-55.89,4.44-121.69C507,155.89,471.59,156,461.9,139.4,446.43,113,448.2,80.3,427,56.69c-26.78-29.87-87-39.52-129.58-40.31-36.18-.67-72.57,8.12-102.64,24.72C173.19,53,159.3,71.64,140.11,85.77,119,101.31,90.74,104.69,68.57,118.5,48.57,131,5,148.92.42,195.56c-4.31,43.73,25.67,88.22,54,104.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M547.83,308.39c0-15.6-122-28.23-272.57-28.23S2.7,292.79,2.7,308.39s122,28.22,272.56,28.22S547.83,324,547.83,308.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M146.39,305.79l-.16.07H113.61c.31-1.16,1.38-3.28,5.11-3.89,5.06-.82,13.83-3.76,15.79-10.23.06-.21.11-.42.16-.64,1.56-6.92,12.85,2.12,12.85,2.12s0,.27.09.74C147.87,296.5,148.54,304.71,146.39,305.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M103.26,188.65s21.21,75.34,27.6,104.48c0,0,15.74,3.16,18.19-1.79,0,0-5.07-82-14.4-92.47C123,185.9,103.26,188.65,103.26,188.65Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-46",
  x: 153.92,
  y: 240.99,
  width: 257.49,
  height: 65.65
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-47",
  x: 153.92,
  y: 261.28,
  width: 257.49,
  height: 6.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-48",
  x: 148.93,
  y: 219.61,
  width: 267.46,
  height: 41.67
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-49",
  x: 148.93,
  y: 219.61,
  width: 267.46,
  height: 41.67
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M162.6,219.61H148.93v13.67A14.17,14.17,0,0,0,162.6,219.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M402.21,219.61a14.2,14.2,0,0,0,14.18,13.7v-13.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M156.45,224.75a2.37,2.37,0,1,1-2.36-2.37A2.36,2.36,0,0,1,156.45,224.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M413.77,224.75a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,413.77,224.75Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-50",
  x: 177.26,
  y: 261.28,
  width: 22.44,
  height: 22.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M195.56,272.5a7.08,7.08,0,1,1-7.08-7.07A7.07,7.07,0,0,1,195.56,272.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M192.06,275.91l-1.7-4.23a2.21,2.21,0,0,0,.4-1.21,2.28,2.28,0,1,0-4.16,1.21l-1.7,4.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M181.21,264a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,181.21,264Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M198.61,264a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,198.61,264Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M181.21,281a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,181.21,281Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M198.61,281a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,198.61,281Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-50",
  x: 365.62,
  y: 261.28,
  width: 22.44,
  height: 22.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M383.91,272.5a7.07,7.07,0,1,1-7.07-7.07A7.06,7.06,0,0,1,383.91,272.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M380.42,275.91l-1.7-4.23a2.2,2.2,0,0,0,.39-1.21,2.27,2.27,0,1,0-4.54,0,2.2,2.2,0,0,0,.39,1.21l-1.7,4.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M369.57,264a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,369.57,264Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M387,264a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,387,264Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M369.57,281a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,369.57,281Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M387,281a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,387,281Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M411.4,292.46a14.19,14.19,0,0,0-13.69,14.18H411.4Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-50",
  x: 242.07,
  y: 271.78,
  width: 15.98,
  height: 11.94
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-50",
  x: 307.27,
  y: 271.78,
  width: 15.98,
  height: 11.94
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M247.79,280.69c11,22.69,58.69,22.69,69.74,0,2.14-4.4-4.42-8.26-6.57-3.85-8.64,17.75-48,17.75-56.6,0-2.15-4.41-8.71-.55-6.57,3.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M408.58,301.2a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,408.58,301.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M168.1,306.64a14.2,14.2,0,0,0-14.18-13.7v13.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M159.35,303.81a2.37,2.37,0,1,1,2.37-2.37A2.37,2.37,0,0,1,159.35,303.81Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-51"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M354.14,68a10.25,10.25,0,1,0,10.25,10.25A10.22,10.22,0,0,0,354.14,68Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-53"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-53"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-54",
  points: "351.01 73.35 445.57 3.9 358.5 80.16 351.01 73.35"
}))), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M349.57,76.08a9.74,9.74,0,0,1,4.66-2.25c-1.29,1.77-1.93,3.86-2.9,5.78.81-.48,1.45-1.28,2.25-1.76,0,.48-.48,1-.48,1.44a24.88,24.88,0,0,0,3.38-2.41,8.74,8.74,0,0,1-1,3.37c1.29-1.28,2.9-2.56,3.06-4.33a8.59,8.59,0,0,1-1,5.62,6.9,6.9,0,0,0,1.84-1.93,6,6,0,0,0,.25-1.69,5.89,5.89,0,0,0-10.36-3.83,4.94,4.94,0,0,1,1.68-.74A8.94,8.94,0,0,0,349.57,76.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M357.6,81.54a8.59,8.59,0,0,0,1-5.62c-.16,1.77-1.77,3-3.06,4.33a8.74,8.74,0,0,0,1-3.37,24.88,24.88,0,0,1-3.38,2.41c0-.48.48-1,.48-1.44-.8.48-1.44,1.28-2.25,1.76,1-1.92,1.61-4,2.9-5.78a9.74,9.74,0,0,0-4.66,2.25A8.94,8.94,0,0,1,351,73.35a4.94,4.94,0,0,0-1.68.74,5.89,5.89,0,1,0,10.11,5.52A6.9,6.9,0,0,1,357.6,81.54Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-57"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-58",
  points: "365.52 56.32 416.57 22.35 366.92 57.78 365.52 56.32"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M367.22,57.11a1,1,0,1,1-1-1.11A1,1,0,0,1,367.22,57.11Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-60"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M369.74,54.62A10.71,10.71,0,0,0,366.21,56a1,1,0,0,0-.72.28,1,1,0,0,0-.32.64,1,1,0,0,0,2,.51s0-.09.05-.14A10.75,10.75,0,0,0,369.74,54.62Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-62"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-63",
  points: "384.62 52.71 426.66 19.19 384.95 53.01 384.62 52.71"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M385,52.86a.23.23,0,0,1-.23.23.24.24,0,0,1-.23-.24.23.23,0,0,1,.24-.22A.22.22,0,0,1,385,52.86Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-64"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-65",
  d: "M385.53,52.28a2.22,2.22,0,0,0-.76.35.29.29,0,0,0-.16.07.25.25,0,0,0-.06.15.23.23,0,0,0,.44.09s0,0,0,0A2.59,2.59,0,0,0,385.53,52.28Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-66"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-67",
  points: "362.15 66.93 419.46 23.7 363.13 67.89 362.15 66.93"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M363.32,67.43a.7.7,0,0,1-.73.68.71.71,0,1,1,.05-1.42A.7.7,0,0,1,363.32,67.43Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-68"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-69",
  d: "M365,65.67a7.55,7.55,0,0,0-2.38,1,.73.73,0,0,0-.49.21.69.69,0,0,0-.2.44.71.71,0,0,0,.65.76.72.72,0,0,0,.71-.45l0-.1A7.23,7.23,0,0,0,365,65.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-70"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-71",
  d: "M372.48,61.77A60.64,60.64,0,0,0,353.32,72a5.88,5.88,0,1,0,6.17,7.55,7.68,7.68,0,0,0,.19-.83A61.29,61.29,0,0,0,372.48,61.77Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-72"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-72"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-72"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-73",
  d: "M368,2.85A8.34,8.34,0,0,0,356.28,2L280,66.8a1.75,1.75,0,0,1-2.53-.27l0,0a1.76,1.76,0,0,1,.24-2.4l45.49-39.21A5.47,5.47,0,0,0,316,16.6L221.94,97.51c-2.12,1.83-2.49,6.6-.95,8.86,3.21,2.93,3.15,7.26,5.85,10.62l5-4.33a5.33,5.33,0,0,0,1.08,1.94l4,4.69a5.5,5.5,0,0,0,7.73.57L367.12,14.65A8.33,8.33,0,0,0,368,2.85Z"
})))), /*#__PURE__*/React.createElement("g", {
  className: "cls-74"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-74"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-74"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-75",
  x: 219.1,
  y: 56.69,
  width: 75.09,
  height: 7.04,
  rx: 2.12,
  transform: "translate(22.72 181.75) rotate(-40.66)"
})))), /*#__PURE__*/React.createElement("path", {
  className: "cls-76",
  d: "M228.56,87c.1.27.73,0,.82-.45-.54,0-.54-1-.18-1.17.54-.37,1.35-.28,1.81-.64.27-.18,0-.81-.18-.9-.73-.27-1.54-1-1.45-1.54.27-1.08,3.26-2.53,1.36-3.25-.37-.09-.55,1.08-.91,1a1.77,1.77,0,0,1-1.29-1.26l-3.44,2.66a1,1,0,0,0-.25,1.38L227,86.3C227.66,86.18,228.2,86.06,228.56,87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M233.93,82l-1.14-1a1,1,0,0,1-.31-1.07l.18-.64A1,1,0,0,0,231.9,78l-1.23-.31a1.08,1.08,0,0,0-.89.19l-1.24,1a1.77,1.77,0,0,0,1.29,1.26c.36.09.54-1.08.91-1,1.9.72-1.09,2.17-1.36,3.25-.09.55.72,1.27,1.45,1.54.18.09.45.72.18.9-.46.36-1.27.27-1.81.64-.36.18-.36,1.17.18,1.17-.09.45-.72.72-.82.45-.36-1-.9-.83-1.53-.71l.57.92a1.06,1.06,0,0,0,1.18.45l4.6-1.35a1.06,1.06,0,0,0,.75-.94l.15-2.58A1.06,1.06,0,0,0,233.93,82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-76",
  d: "M253.24,110.54c.53-.18.78-.67,1.24-1-.32-.43,0-.57.07-1,0-.24-.25-.49-.5-.66,0,0-.07.1-.14.07a.32.32,0,0,1-.07-.29c.21-.24.78-.21.67-.63-.27.09-.44,0-.5-.23l-.72.09a.56.56,0,0,0-.49.52v.3a.57.57,0,0,1-.29.46l-.26.14a.56.56,0,0,0-.2.8l.85,1.26C253,110.38,253.16,110.32,253.24,110.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M255.83,108.25,254.74,107a.54.54,0,0,0-.48-.18l-.25,0c.06.23.23.32.5.23.11.42-.46.39-.67.63a.32.32,0,0,0,.07.29c.07,0,.11-.07.14-.07.25.17.53.42.5.66,0,.39-.39.53-.07,1-.46.28-.71.77-1.24,1-.08-.22-.23-.16-.35-.08l.13.2a.56.56,0,0,0,.84.11l1.92-1.74A.55.55,0,0,0,255.83,108.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-76",
  d: "M231.22,120.84c-.77-1.53-3.31,1-4.07.25-1.53-1.27-2.55-3.3-3.57-5.08-.51-1,1.53-1.78,1.53-2-1-4.06.76-5.84,3.82-6.1,2.8-.25,5.34,4.83,7.89,4.32,2.8-.5,6.36-6.35,1.78-7.37-1.27-.25-3.06-.51-2.55-1.27,1.53-3.56,5.35-6.36,8.15-9.41-3-1.91-1.69-3.64.15-5.35a2.17,2.17,0,0,0-2.13.17l-8.53,5.8a2.19,2.19,0,0,1-1.36.37l-4.21-.3A2.29,2.29,0,0,0,227,95l-5.09,2.47a2.12,2.12,0,0,0-.9.83l-1.51,2.51a2.13,2.13,0,0,1-.89.82,2.14,2.14,0,0,0-1.12,1.39l-.72,2.83a2.13,2.13,0,0,1-.65,1.06l-.64.58a2.15,2.15,0,0,0-.71,1.62l.07,7.48a2.23,2.23,0,0,0,.32,1.1l2.09,3.39a2.14,2.14,0,0,0,1.39,1l11.72,2.45C231.2,123.27,232,122.05,231.22,120.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M249.11,97.39a2.13,2.13,0,0,0-.16-2l-3.7-5.81a2.22,2.22,0,0,0-.9-.8c-1.84,1.71-3.13,3.44-.15,5.35-2.8,3-6.62,5.85-8.15,9.41-.51.76,1.28,1,2.55,1.27,4.58,1,1,6.87-1.78,7.37-2.55.51-5.09-4.57-7.89-4.32-3.06.26-4.84,2-3.82,6.1,0,.26-2,1-1.53,2,1,1.78,2,3.81,3.57,5.08.76.77,3.3-1.78,4.07-.25.76,1.21,0,2.43-.83,3.7l2.69.56a2.16,2.16,0,0,0,2.19-.85l1.36-1.89a2.14,2.14,0,0,1,1.58-.89L245,121a2.17,2.17,0,0,0,1.93-1.66l1.66-7.19a2.18,2.18,0,0,0-.09-1.24l-2.1-5.54a2.14,2.14,0,0,1,0-1.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M229.29,103.58c-.18.39.23.78.59,1l.74.47a.58.58,0,0,1,.25.24c.13.3-.25.55-.38.85a.81.81,0,0,0,.14.81,2.26,2.26,0,0,0,.65.54l.88.56a.81.81,0,0,0,.44.18.87.87,0,0,0,.56-.33c.41-.43.82-.87,1.22-1.31a2.24,2.24,0,0,0,.52-.82,2.16,2.16,0,0,0-.61-1.7c-.27-.35-.53-.7-.83-1A2.6,2.6,0,0,0,229.29,103.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M215.73,115a5.39,5.39,0,0,0,.65,1.4c.64,1.06,1.27,2.13,1.9,3.2a2.11,2.11,0,0,0,1.13,1.09c.8.21,1.54-.64,1.59-1.46a5.54,5.54,0,0,0-.66-2.35,1.39,1.39,0,0,1-.1-1,2.23,2.23,0,0,1,.68-.61c1.07-.82,1.13-2.38,1.08-3.72a1.08,1.08,0,0,0-.09-.44c-.67-1.23-3.31-1.88-4.42-1A6.17,6.17,0,0,0,215.73,115Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-77",
  d: "M236.36,96.16c-.11.34.2.67.52.84a.44.44,0,0,0,.15,0,.43.43,0,0,0,.21-.09c.66-.5,2.21-1.16,1.85-2.1a1.43,1.43,0,0,0-1.42-.84c-.43,0-1,.16-1,.67,0,.33.41.53.36.8S236.46,95.87,236.36,96.16Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-78"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-78"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-78"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-78"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-79",
  d: "M413.41,84.88c-2.6-3-69.17,46.58-84.23,59.43-.82.69-1.61,1.39-2.39,2.08l10.12,10.38c.56-.47,1.13-.94,1.69-1.43C353.67,142.49,416,87.92,413.41,84.88Z"
}))))), /*#__PURE__*/React.createElement("g", {
  className: "cls-80"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-81",
  d: "M330.85,139.34a13.22,13.22,0,1,0,13.25,13.23A13.21,13.21,0,0,0,330.85,139.34Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-82"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-82"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-82"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-82"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-83",
  d: "M324.77,151.23s2-10.69,16.31-17.64c0,0-6.71,6.54-8.88,12.29,0,0,8.28-11.58,21.95-16.84,0,0-14.28,10.33-15.85,14.81l4.39-2.33s-1,3.59-3.39,5.34c0,0,21.91-17.18,24.29-21.33,0,0-10.07,19-21.57,25.53,0,0,8.45-2.94,11.31-6.86,0,0-8.19,11.49-18.82,14.06a10.58,10.58,0,0,1-5.09.17C327,157.78,324.15,155.86,324.77,151.23Z"
}))))), /*#__PURE__*/React.createElement("path", {
  className: "cls-84",
  d: "M335.44,154.8c-.95-.31,1.58-1.89.95-2.21-2.21-1-4.43,4.11-6,2.53s2.53-3.79,3.8-6a1.52,1.52,0,0,0-.64-1.9c-3.16-.95-5.06,2.21-7.59,3.16-.31-1.26,1.9-2.21.64-2.84a1.17,1.17,0,0,0-.61-.26,7.43,7.43,0,1,0,12.74,6.28C337.45,153.55,336.17,155.29,335.44,154.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-85",
  d: "M331.38,145a7.42,7.42,0,0,0-5.4,2.32,1.17,1.17,0,0,1,.61.26c1.26.63-.95,1.58-.64,2.84,2.53-.95,4.43-4.11,7.59-3.16a1.52,1.52,0,0,1,.64,1.9c-1.27,2.21-5.38,4.42-3.8,6s3.8-3.48,6-2.53c.63.32-1.9,1.9-.95,2.21.73.49,2-1.25,3.28-1.24a7.62,7.62,0,0,0,.09-1.18A7.42,7.42,0,0,0,331.38,145Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-85",
  d: "M340.11,143.5a.47.47,0,1,1-.47-.47A.47.47,0,0,1,340.11,143.5Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-85",
  cx: 338.97,
  cy: 146.69,
  r: 0.98
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-85",
  cx: 337.76,
  cy: 149.69,
  r: 1.16
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-86"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-86"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-87",
  d: "M424.14,124.85l43.19-31.67a.54.54,0,0,1,.7.82l-37.18,37.45Z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-88"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-89",
  points: "430.5 122.07 451.06 106.17 430.92 122.49 430.5 122.07"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-90"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-91",
  points: "436.95 121.83 462.95 99.11 437.9 122.7 436.95 121.83"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-92",
  d: "M424.47,126c-.79.92-1.45,2.5.07,2.44.72,0,1.57-1.19,2.3-2-.73-.52-.26-1.44.26-1.38,1.32.33,2.43,1.19,3.42-.06,0,.39.59.72.53.79-1.78,1.84-4.34,2.89-5.72,5.12.19.07.32.4.46.27,1.18-1,2.1-2,3.22-3,.33-.26.66.27,1.05.33-.06-.2.13-.13.2-.13-.26.79-.86,1.91.46,2a25.57,25.57,0,0,1,2.49-3.65,2.28,2.28,0,0,0-.24-.66c-.42-.85-1.07-1.83-2-1.75-.55,0-1.12.46-1.59.18s-.43-.68-.76-.88a1.26,1.26,0,0,0-1,0,9.65,9.65,0,0,0-4,1.68A7.06,7.06,0,0,0,424.47,126Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-93",
  d: "M430.72,130.36c-1.32-.06-.72-1.18-.46-2-.07,0-.26-.07-.2.13-.39-.06-.72-.59-1.05-.33-1.12,1-2,2-3.22,3-.14.13-.27-.2-.46-.27,1.38-2.23,3.94-3.28,5.72-5.12.06-.07-.53-.4-.53-.79-1,1.25-2.1.39-3.42.06-.52-.06-1,.86-.26,1.38-.73.79-1.58,2-2.3,2-1.52.06-.86-1.52-.07-2.44a7.06,7.06,0,0,1-.86-.74,4.34,4.34,0,0,0-.7.77,2.22,2.22,0,0,0-.33,2.22c.15.3.38.58.35.9a1.32,1.32,0,0,1-.19.46,3.15,3.15,0,0,0,1.12,4,.73.73,0,0,0,.32.12.88.88,0,0,0,.43-.14l2.75-1.57a2.63,2.63,0,0,1,.79-.34c.67-.12,1.35.3,2,.16s1.08-.85,1.4-1.47l1.44-2.84a1.68,1.68,0,0,0,.22-.6,1.48,1.48,0,0,0,0-.21A25.57,25.57,0,0,0,430.72,130.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-92",
  d: "M430.35,122.26l.19.29a.06.06,0,0,0,.08,0l.3-.09a.06.06,0,0,0,.05-.06v-.17a.14.14,0,0,0,0-.06l-.08-.07a.06.06,0,0,1,0-.07v0a.07.07,0,0,0-.05-.09l-.08,0a.07.07,0,0,0-.06,0l-.31.24A.07.07,0,0,0,430.35,122.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-92",
  d: "M437.9,122.7l.39-.86a.12.12,0,0,0,0-.18l-.61-.26a.18.18,0,0,0-.2,0l-.39.34a.26.26,0,0,0-.1.14l0,.25a.27.27,0,0,1-.13.17l-.11.07a.23.23,0,0,0-.12.25l.07.16a.09.09,0,0,0,.1.06l.95,0A.32.32,0,0,0,437.9,122.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-94",
  d: "M101.5,112.28a15.61,15.61,0,0,0-.31-6.18c-.87-2.81-4.5-10.21-3.35-12.78s5.31-9.5,7.88-9.48-2.7,7.41-2,9.72,1,2.49,1.86,2.29,2.24-4.62,2.7-3.59.18,7.87-.66,9.58.89,11.33.89,11.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-95",
  d: "M99.45,110.78s5.68-3.23,10.07-1.87c0,0,8.72,25.11,13.52,43.57a387.46,387.46,0,0,0,14.89-45.42s11.17,15.43,15.2,25.69S133.06,179,123.71,181.83c-9.76,2.95-8,0-13.49-3.15C108.44,176.38,102.78,164.93,99.45,110.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M73.76,307l-.17.07H41c.31-1.16,1.37-3.27,5.1-3.88,5.06-.82,13.84-3.76,15.79-10.24.06-.2.12-.42.17-.63,1.55-6.92,12.85,2.11,12.85,2.11l.08.75C75.24,297.68,75.9,305.89,73.76,307Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-96",
  d: "M96.93,186.82a42.17,42.17,0,0,1,7.1,4.3,19.17,19.17,0,0,1,1.09-3.74c28-7.29,102.91-6.7,102.91-6.7s16.1,4,11.37,27.48c-4.35,21.58-76.28,11.59-99.52,5.12-.54-.16-1.07-.31-1.58-.48,1.85,13.75-11.1,33.36-22.43,51.41-9.34,14.88-17.29,29.94-17.29,29.94-4.7,2.91-20.45,1.23-20.45,1.23C68.09,267.26,96.93,186.82,96.93,186.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-97",
  d: "M158.7,99.45s-8,25.72-20.11,31.47c0,0-1.14-7.8.81-13.74-1.59-1.22-3-2.35-4.23-3.37a77.82,77.82,0,0,1-6.17-5.58l1.8-12.55L132,87.17a38.23,38.23,0,0,0,6,5.6C148.45,100.54,158.7,99.45,158.7,99.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-94",
  d: "M138,92.77s4,11.14-2.86,21a77.82,77.82,0,0,1-6.17-5.58l1.8-12.55A25.45,25.45,0,0,1,138,92.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-97",
  d: "M125.94,110.66s17.8-11.8,10.28-22.77-10.3-19.88-22-12.81-11,12.76-9.37,17S121.12,113.45,125.94,110.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-98",
  d: "M134.15,64.93c.07-.3.41-.68,1.31-1.18a4.11,4.11,0,0,0-2,.35c-.84-1.21-2.66-3.19-5.15-2.67a3.11,3.11,0,0,1,2.34,1.38c-3.88-1.42-10.34-.68-25,8-19.3,11.45-6.28,21.26-2.92,21.55s7.82-7.19,12.85-9.18,9.44,4.68,11.56,4.85.63-1.24,2.36-3.35,3.76,1.53,4.31,4.27,5.18,4.46,5.18,4.46l1.43-4.89c1.43-4.88-2.66-20.61-5.56-23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-99",
  d: "M137.05,142.31a174,174,0,0,0,10.87,21.8c2.3,3.8,4.77,7.3,7,10.35l.22.29c4.45,6,11.26,7.64,11.05,9.14-.43,3,7.19,10.25,19.74,13.46,14.57,3.72,31.45,5.51,35.71.59,1.43-1.66,1.9-4.7,1.75-8.48-.32-8-10.34-40-10.34-40-17.14-51.89-66.24-51.89-66.24-51.89s1,12.43-11.09,16.74C135.74,114.32,132.92,132.54,137.05,142.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-97",
  d: "M108.21,179.23s-7.37,2.6-9.39,3.87-6.68,7.63-7.2,9.87-1.14,8.79-.76,9.89,6-3.11,7.28-7.07,4.48-5,4.35-4.82-1.77,5.29-1.42,5.51,1.85.59,3.21-2.24,4.06-4.9,3.55-7.83A23.76,23.76,0,0,1,108.21,179.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-95",
  d: "M166,184.31c-.43,3,7.43,9.83,20,13,10.47-20.84-9.44-68.52-9.44-68.52L155,174.46C159.5,180.6,166.19,182.79,166,184.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-95",
  d: "M147.92,164.11c2.3,3.8,4.77,7.3,7,10.35l.22.29a17.4,17.4,0,0,0,7.37-5.51c3.4-4.79,3.68-33.63,3.68-33.63S152.31,152.79,147.92,164.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-99",
  d: "M105.38,179.87s33.64-9.41,50.91-13.53c-1.52-20.38-6.51-82,24.86-57.31,0,0,2.37,66-12.83,79.37,0,0-48.8,1-58.09.47,0,0-2.73-1.41-3.41-2.36A9.28,9.28,0,0,1,105.38,179.87Z"
}))));

var SvgLostNoValuation = function SvgLostNoValuation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 550 336.61",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLostNoValuation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lost_no_valuation.d0dfa694.svg";
export { ForwardRef as ReactComponent };